/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Advanced from './Advanced/index'
import Inline from './Inline/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/EmailTemplateEditor/Content/SwitchEditor/Option"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Inline'
let eventActionDataEmailTemplateAdvancedEditorValueData = fromData.useDataFormat({ viewPath,
context: 'event_action',
path: 'data.email_template.advanced_editor',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventActionDataEmailTemplateAdvancedEditorValueData,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Option.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-2-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-3-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-4-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-5-Z2h7tiu': dtColorsNeutral200,'--btlr-6-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-7-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-8-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-9-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'Inline'}>
<Inline
  viewPath={`${viewPath}/Inline`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Advanced'}>
<Advanced
  viewPath={`${viewPath}/Advanced`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}